/**
 * 默认订阅状态 resolver（应用启动时由 OspApiClientProvider 注册）：
 *
 * - 订阅状态：`GET /v2/agents/preferences`（memberApi）→ `subscribed_scenes`
 *   包含 `WEEKLY_THEME_RANKING` → 已订阅（不弹）；
 * - 邮箱信息：`GET /v2/platform/owners`（openApi）→ `issue_email`，
 *   缓存到模块内供输入框预填（无邮箱时留空由用户输入）。
 *
 * 查询失败 → "unknown"（fail-open，仍弹出）。
 */

import type { MemberClient } from "@features/api/memberApi";
import type { OpenApiClient } from "@features/api/openApi";
import type { SubscribeEmailStatusResolver } from "./subscribeEmailPromptGate";

/** 订阅场景 key（后端 AgentConstants.SubscribedScene） */
export const WEEKLY_THEME_RANKING = "WEEKLY_THEME_RANKING";

/** 与 IOspApiClientContext 一致的客户端类型（<any> SecurityDataType） */
type OpenApiAnyClient = OpenApiClient<any>;
type MemberAnyClient = MemberClient<any>;

/** 最近一次查到的注册邮箱（gate 判定时顺带缓存，供输入框预填） */
let lastKnownOwnerEmail: string | null = null;

export function getLastKnownOwnerEmail(): string | null {
  return lastKnownOwnerEmail;
}

export function createSubscribeEmailStatusResolver(clients: {
  openApi?: OpenApiAnyClient;
  memberApi?: MemberAnyClient;
}): SubscribeEmailStatusResolver {
  return async () => {
    const [ownerResult, preferenceResult] = await Promise.allSettled([
      clients.openApi?.owners.getOwnerInfo(),
      clients.memberApi?.agents.getPreference(),
    ]);

    if (ownerResult.status === "fulfilled") {
      lastKnownOwnerEmail =
        ownerResult.value?.data?.data?.issue_email?.trim() || null;
    }

    if (preferenceResult.status === "fulfilled") {
      const scenes =
        preferenceResult.value?.data?.data?.subscribed_scenes ?? {};
      if (scenes[WEEKLY_THEME_RANKING] !== undefined) {
        return "subscribed";
      }
      return "not_subscribed";
    }

    // 任一关键查询失败（preference 拿不到）→ unknown，不阻塞弹出
    return "unknown";
  };
}
